import {
  CONTACT,
  FORM_SUBTITLE,
  INTRO_PARAGRAPHS,
  NOTES,
  PROJECT_TITLE,
  SERVICE_RULES,
} from "../content";
import { boldHours } from "../lib/text";

export default function IntroCard() {
  return (
    <>
      <div className="hero">
        <h1>{PROJECT_TITLE}</h1>
        <div className="hero-sub">{FORM_SUBTITLE}</div>
        {INTRO_PARAGRAPHS.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>

      <div className="card intro-block">
        <h2>{SERVICE_RULES.heading}</h2>
        <h3>{SERVICE_RULES.subheading}</h3>
        {SERVICE_RULES.body.map((p, i) => (
          <p key={i}>{boldHours(p)}</p>
        ))}

        <div className="notes-box">
          <strong>{NOTES.heading}</strong>
          <ul>
            {NOTES.items.map((parts, i) => (
              <li key={i}>
                {parts.map((p, j) =>
                  typeof p === "string" ? (
                    <span key={j}>{p}</span>
                  ) : (
                    <span key={j} className={`nb-hl nb-${p.hl}`}>
                      {p.text}
                    </span>
                  ),
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="contact">
          客服專線：<a href={`tel:${CONTACT.hotline}`}>{CONTACT.hotline}</a>
          <br />
          客服信箱：<a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
        </div>
      </div>
    </>
  );
}
